<template>
  <div class="submenu_permission">
    <div class="background-shapes">
      <div class="shape triangle-1"></div>
      <div class="shape triangle-2"></div>
      <div class="shape circle"></div>
    </div>
    <div class="row menu-form">
      <div class="col-12 mb-3">
        <b-card class="rounded-1 text-white bg-primary shadow-lg">
          <h5 class="mb-0 text-uppercase fw-bold">
            {{ $t("Allowed IP Address") }}
          </h5>
        </b-card>
      </div>

      <b-form
        @submit.prevent="onSubmit"
        @reset.prevent="onReset"
        class="col-12"
      >
        <b-card class="p-3">
          <div class="row">
            <div class="col-md-6 mb-3">
              <b-form-group
                label="IP Address"
                label-for="ip-address"
                class="text-uppercase fw-bold"
              >
                <template v-slot:label>
                  {{ $t("IP Address") }}
                </template>
                <b-form-input
                  id="ip-address"
                  v-model="form.ip"
                  type="text"
                  placeholder="e.g. 192.168.0.1"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-md-6 mb-3">
              <b-form-group
                label="User Name"
                label-for="label"
                class="text-uppercase fw-bold"
              >
              <template v-slot:label>
                    {{ $t("User Name") }}
                  </template>
                  
                <b-form-input
                  id="label"
                  v-model="form.username"
                  placeholder="User Name"
                  required
                  :readonly="isEdit == true"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Status" class="text-uppercase fw-bold">
                <template v-slot:label>
                    {{ $t("Status") }}
                  </template>
                <b-form-radio-group
                  id="active_yn"
                  v-model="form.activeYn"
                  :options="options"
                  :button-variant="
                    form.activeYn === 'N' ? 'outline-danger' : 'outline-success'
                  "
                  name="active_yn"
                  buttons
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2">
            <b-button type="submit" variant="success" class="text-white"
              >{{ $t("Save") }}</b-button
            >
            <b-button type="reset" variant="outline-secondary">{{ $t("Clear") }}</b-button>
          </div>
        </b-card>
        <div class="card p-4 mt-4">
          <h5
            class="bg-success p-3 rounded-1 text-white fw-bold text-uppercase"
          >
            {{ $t("IP Allowed List") }}
          </h5>
          <div
            class="card-body mt-4 col-md-12"
            v-if="getIpAddressData.length > 0"
          >
            <table class="table table-striped">
              <thead>
                <tr>
                  <th v-for="(header, index) in headers" :key="index">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in paginatedItems" :key="item.requestKey">
                  <td v-for="(header, hIndex) in headers" :key="hIndex">
                    <template v-if="header.value === 'activeYn'">
                      <span>{{
                        item.activeYn === "Y" ? "Active" : "Inactive"
                      }}</span>
                    </template>
                    <template v-else-if="header.value === 'action2'">
                      <a class="btn text-dark" @click.prevent="editItem(item)">
                        <font-awesome-icon icon="pen-to-square" />
                      </a>
                      <a class="btn text-dark" @click="removeIpAddress(item)">
                        <font-awesome-icon class="text-danger" icon="trash" />
                      </a>
                    </template>
                    <template v-else>
                      {{ item[header.value] }}
                    </template>
                  </td>
                </tr>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    class="btn btn-outline-success"
                    :disabled="currentPage === 1"
                    @click="currentPage--"
                    >Previous
                  </b-button>

                  <span>Page {{ currentPage }} of {{ totalPages }}</span>

                  <b-button
                    class="btn btn-outline-success"
                    :disabled="currentPage === totalPages"
                    @click="currentPage++"
                    >Next
                  </b-button>
                </div>
              </tbody>
            </table>
          </div>
          <div class="border text-center" v-else>Data Not Found !!</div>
        </div>
      </b-form>
    </div>
  </div>
  <!--    here is my dummy template-->
  <!--<div class="col-auto mt-4">
        <a class="btn btn-success" @click="downloadJPG">
            <font-awesome-icon class="text-white" icon="download"/>
        </a>
    </div>-->

  <!--<div class="certificate" role="main" aria-label="সম্পত্তি বণ্টনের ইউনিক প্রিমিয়াম সার্টিফিকেট" ref="download_section">

        <h1>সম্পত্তি বণ্টন</h1>
        <h2>আইনানুগ ও স্বীকৃত সম্পত্তি বণ্টনের সনদপত্র</h2>
        <p class="description">
            পরিবারের ওয়ারিশগণের মধ্যে সম্পত্তির সুষ্ঠু ও স্বচ্ছ বণ্টনের উদ্দেশ্যে এই সনদপত্র প্রস্তুত করা হয়েছে।</p>

        <table role="table" aria-label="সম্পত্তি বণ্টনের তথ্য">
            <thead>
            <tr>
                <th scope="col">স্বজনের নাম</th>
                <th scope="col">অংশ</th>
                <th scope="col">জমির পরিমাণ (শতাংশ)</th>
                <th scope="col">সোনার পরিমাণ (ভরি)</th>
                <th scope="col">রূপার পরিমাণ (ভরি)</th>
                <th scope="col">টাকা (৳)</th>
            </tr>
            </thead>
            <tbody><tr>
                <td>কন্যা</td>
                <td>0.1082</td>
                <td>2.164</td>
                <td>0.541</td>
                <td>0.541</td>
                <td class="currency">21,640</td>
            </tr>
            <tr>
                <td>স্ত্রী</td>
                <td>0.1250</td>
                <td>2.500</td>
                <td>0.625</td>
                <td>0.625</td>
                <td class="currency">25,000</td>
            </tr>
            <tr>
                <td>মাতা</td>
                <td>0.1670</td>
                <td>3.340</td>
                <td>0.835</td>
                <td>0.835</td>
                <td class="currency">33,400</td>
            </tr>
            <tr>
                <td>পিতা</td>
                <td>0.1670</td>
                <td>3.340</td>
                <td>0.835</td>
                <td>0.835</td>
                <td class="currency">33,400</td>
            </tr>
            <tr>
                <td>পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>
            <tr>
                <td>পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>

            <tr>
                <td>পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>

            <tr>
                <td>পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>

            <tr>
                <td>মৃত পুত্র ১ এর পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>
            <tr>
                <td>মৃত পুত্র ১ এর পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>
            <tr>
                <td>মৃত পুত্র ১ এর পুত্র</td>
                <td>0.2164</td>
                <td>4.328</td>
                <td>1.082</td>
                <td>1.082</td>
                <td class="currency">43,280</td>
            </tr>
            </tbody>
        </table>

        <section class="signature-section" aria-label="সাক্ষরের স্থান">
            <div class="signature-block" tabindex="0">
                <div class="signature-line" aria-hidden="true"></div>
                <div class="signature-title">স্বত্বাধিকারীর স্বাক্ষর</div>
                <div class="signature-subtitle">(নাম ও স্বাক্ষর)</div>
            </div>
            <div class="signature-block" tabindex="0">
                <div class="signature-line" aria-hidden="true"></div>
                <div class="signature-title">প্রসিকিউটরের স্বাক্ষর</div>
                <div class="signature-subtitle">(নাম ও স্বাক্ষর)</div>
            </div>
        </section><p class="footer-date">ইস্যুর তারিখ: <time datetime="2024-06-01">২৮ মে ২০২৫</time></p>
    </div>-->
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";
import html2canvas from "html2canvas";

export default {
  name: "ipAllowed",
  components: {
    //
  },
  data() {
    return {
      form: {
        ip: "",
        username: "",
        requestKey: "",
        activeYn: "Y",
      },
      isEdit: false,
      ipAddressData: null,
      getIpAddressData: [],
      currentPage: 1,
      perPage: 5,
      options: [
        { text: "YES", value: "Y" },
        { text: "NO", value: "N" },
      ],
      headers: [
        { text: "User Name", value: "username" },
        { text: "IP Address", value: "ip" },
        { text: "Status", value: "activeYn" },
        { text: "Action", value: "action2" },
      ],
    };
  },
  mounted() {
    this.getAllIP();
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.getIpAddressData.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.getIpAddressData.length / this.perPage);
    },
  },
  methods: {
    onSubmit() {
      apiRepository
        .iPAddressDataGet(this.form)
        .then((res) => {
          if (res) {
            toast.success(res.data);
            this.getAllIP();
          }
        })
        .catch((error) => {
          toast.error(error.response?.data);
        });
    },
    editItem(item) {
      this.form = {
        ...item,
      };
      this.isEdit = true;
    },
    getAllIP() {
      apiRepository.getIpData().then((res) => {
        if (res) {
          this.getIpAddressData = res.data;
        }
      });
    },
    removeIpAddress(item) {
      apiRepository
        .deleteIp(item)
        .then((res) => {
          if (res) {
            toast.success(res.data);
            this.getAllIP();
          }
        })
        .catch((error) => {
          toast.error(error.response?.data);
        });
    },

    onReset() {
      this.form = {
        ip: "",
        username: "",
        requestKey: "",
        activeYn: "Y",
      };
    },

    async downloadJPG() {
      const element = this.$refs.download_section;

      try {
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          scrollY: -window.scrollY,
        });

        const image = canvas.toDataURL("image/jpeg", 0.98);

        const link = document.createElement("a");
        link.href = image;
        link.download = "wasiyyah-legal.jpg";
        link.click();
      } catch (error) {
        console.error("Error generating JPG:", error);
      }
    },
  },
};
</script>

<style scoped>
/*background style*/
.submenu_permission {
  position: relative;
  padding: 2rem;
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  border-radius: 15px;
  overflow: hidden;
}

.background-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.3);
}

.triangle-1 {
  width: 0;
  height: 0;
  border-left: 100px solid transparent;
  border-right: 100px solid transparent;
  border-bottom: 200px solid rgba(255, 99, 71, 0.3);
  top: -50px;
  left: -50px;
  transform: rotate(45deg);
}

.triangle-2 {
  width: 0;
  height: 0;
  border-left: 80px solid transparent;
  border-right: 80px solid transparent;
  border-bottom: 160px solid rgba(70, 130, 180, 0.3);
  bottom: -80px;
  right: -80px;
  transform: rotate(-30deg);
}

.circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: rgba(144, 238, 144, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.menu-form {
  position: relative;
  z-index: 2;
  /*background: rgba(255, 255, 255, 0.9);*/
  padding: 2rem;
  border-radius: 10px;
  /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
  animation: fadeIn 0.5s ease-in-out;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  text-align: left !important;
}

/*!*dummy code*!
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&amp;family=Poppins:wght@300&amp;display=swap');

    !* Reset *!
    *, *::before, *::after {
        box-sizing: border-box;
    }
    body {
        margin: 0;
        background: linear-gradient(135deg, #1f2732, #5b3a00);
        font-family: 'Poppins', sans-serif;
        color: #f3eac2;
        min-height: 100vh;
        padding: 60px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .certificate {
        position: relative;
        max-width: 900px;
        width: 100%;
        background: radial-gradient(circle at top left, #f8f4e3, #d4c69b);
        border-radius: 30px;
        padding: 48px 72px 72px;
        box-shadow:
                inset 0 0 20px 1px #fff2c8aa,
                0 8px 50px #7a5e1c;
        overflow: hidden;
    }

    !* Decorative Frame *!
    .certificate::before,
    .certificate::after {
        content: "";
        position: absolute;
        border: 3px solid #b29300;
        border-radius: 32px;
        pointer-events: none;
    }
    .certificate::before {
        top: 12px;
        left: 12px;
        right: 12px;
        bottom: 12px;
    }
    .certificate::after {
        top: 24px;
        left: 24px;
        right: 24px;
        bottom: 24px;
        border-style: dashed;
        opacity: 0.6;
    }

    !* Title *!
    h1 {
        font-family: 'Playfair Display', serif;
        text-align: center;
        font-weight: 700;
        font-size: 3.5rem;
        letter-spacing: 0.25em;
        color: #795600;
        text-transform: uppercase;
        margin: 0 0 6px;
        text-shadow:
                0 0 10px #d3b73d80,
                0 1px 1px #4d3900;
    }

    !* Subtitle *!
    h2 {
        font-family: 'Playfair Display', serif;
        font-weight: 400;
        font-style: italic;
        text-align: center;
        color: #a1831e;
        font-size: 1.3rem;
        margin: 0 0 30px;
        text-shadow: 0 0 8px #c6b14480;
    }

    !* Info Paragraph *!
    p.description {
        max-width: 650px;
        margin: 0 auto 48px;
        text-align: center;
        font-size: 1.1rem;
        color: #5d4e19;
        font-weight: 500;
        letter-spacing: 0.05em;
    }

    !* Elegant Table *!
    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 12px;
        font-size: 1.1rem;
        color: #594a14;
        box-shadow:
                inset 0 0 18px #fef7d5;
    }
    thead {
        background: linear-gradient(90deg, #a68f1a, #f2e9a1);
        box-shadow: inset 0 -3px 6px #7e690f;
    }
    thead th {
        padding: 14px 22px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #4a3e08;
        border-left: 2px solid transparent;
        border-right: 2px solid transparent;
        user-select: none;
    }
    thead th:first-child {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }
    thead th:last-child {
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
    }

    tbody tr {
        background: #fef7d5cc;
        border-radius: 12px;
        box-shadow: 0 2px 8px #caba6e99;
        transition: background 0.3s ease;
    }
    tbody tr:hover {
        background: #f4eb91ff;
    }
    tbody td {
        padding: 14px 22px;
        border: none;
        text-align: center;
        vertical-align: middle;
    }
    tbody td:first-child {
        font-weight: 600;
        color: #6b5410;
    }
    tbody td.currency {
        font-weight: 700;
        color: #856e00;
    }

    !* Signature Section *!
    .signature-section {
        display: flex;
        justify-content: space-around;
        margin-top: 70px;
        gap: 60px;
        flex-wrap: wrap;
    }
    .signature-block {
        width: 260px;
        text-align: center;
        color: #5e4b0a;
        font-family: 'Playfair Display', serif;
    }
    .signature-line {
        border-bottom: 3px solid #b19200;
        width: 100%;
        max-width: 260px;
        margin-bottom: 12px;
        box-shadow: 0 2px 6px #7a6900aa;
    }
    .signature-title {
        font-weight: 700;
        font-size: 1.2rem;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        margin-bottom: 4px;
    }
    .signature-subtitle {
        font-style: italic;
        font-weight: 400;
        font-size: 0.9rem;
    }

    !* Footer Date *!
    .footer-date {
        margin-top: 60px;
        text-align: center;
        color: #5a4e0a;
        font-weight: 500;
        letter-spacing: 0.05em;
        font-size: 1rem;
        font-family: 'Poppins', sans-serif;
    }

    !* Responsive adjustments *!
    @media (max-width: 720px) {
        .certificate {
            padding: 36px 36px 56px;
        }
        h1 {
            font-size: 2.8rem;
            letter-spacing: 0.15em;
        }
        h2 {
            font-size: 1.15rem;
            margin-bottom: 24px;
        }
        table thead th, tbody td {
            padding: 11px 14px;
            font-size: 1rem;
        }
        .signature-section {
            justify-content: center;
            gap: 40px;
        }
        .signature-block {
            width: 220px;
        }
    }*/
</style>
